<!-- Google Tag Manager (noscript) -->
<noscript><iframe title="googleTag" [src]="googleTagUrl | sanitizer: 'resourceUrl'"
                  height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->
<router-outlet></router-outlet>
